import type { ImageElement, Persisted } from '@tunasong/schemas'
import type { FC } from 'react'
import styles from './background-image.module.css'

interface BackgroundImageProps {
  image: Persisted<ImageElement>
}

export const BackgroundImage: FC<BackgroundImageProps> = props => {
  const { image } = props
  const url = image.storageUrls?.sizes?.large

  return (
    <>
      <img src={url} className={styles.image} />
      <div className={styles.overlay} />
    </>
  )
}
